export type OrderStatus = (typeof OrderStatusEnum)[keyof typeof OrderStatusEnum];
export const enum OrderStatusEnum {
  AWAITING = 'AWAITING',
  AWAITING_DISTRIBUTION = 'AWAITING_DISTRIBUTION',
  PROCESSING = 'PROCESSING',
  READY_FOR_SHIPPING = 'READY_FOR_SHIPPING',
  IN_TRANSIT = 'IN_TRANSIT',
  AWAITING_INVOICE = 'AWAITING_INVOICE',
  COMPLETED = 'COMPLETED',
  VOIDED = 'VOIDED',
}

export interface Product {
  id: string;
  name: string;
  quantity: number;
  unit?: string;
}

export interface ReturnedContainer {
  quantity: number;
  type: string;
}

export interface AvailableProduct {
  id: string;
  name: string;
  availableUnits: string[]; // Array of possible units
  defaultUnit?: string; // Default unit to use
}

export interface OrderHistory extends Order {
  change: { type: 'status' | 'orderEmail'; from: OrderStatusEnum; to: OrderStatusEnum };
  updatedBy: { id: string; displayName: string };
}

export interface DBOrder {
  id: string;
  orgId: string;
  companyName: string;
  products: Product[];
  delivery: {
    date: Date;
    address: string;
    zip: string;
    city: string;
    att: string;
    nextExpectedDeliveryDate: Date;
  };
  orderRef?: string;
  terms?: string;
  invoiceEmail: string;
  invoiceNo?: string;
  eanNumber?: string;
  cvrNumber?: string;
  internalNote?: string;
  status: OrderStatus;
  contact: { name: string };
  createdBy: { id: string; displayName: string };
  createTime: Date;
  updateTime: Date;
  returnedContainers?: ReturnedContainer[];
  isIntermediateStorage?: boolean;
  // history?: OrderHistory[]; // Made optional since it will be loaded separately
}
export interface Order {
  id: string;
  orgId: string;
  companyName: string;
  products: Product[];
  deliveryDate?: Date;
  status: OrderStatus;
  deliveryAddress?: string;
  nextExpectedDeliveryDate?: Date;
  deliveryZip?: string;
  deliveryCity?: string;
  deliveryAtt?: string;
  orderRef?: string;
  terms?: string;
  invoiceEmail?: string;
  eanNumber?: string;
  cvrNumber?: string;
  internalNote?: string;
  contactPerson?: string;
  createdBy: { id: string; displayName: string };
  createTime: Date;
  updateTime?: Date;
  returnedContainers?: ReturnedContainer[];
  intermediateStorage?: string;
  invoiceNo?: string;
  deliveryDateIsFallback?: boolean;
  productDataIncomplete?: boolean;
  isDeprecatedOrder?: boolean;
  // history?: OrderHistory[]; // Made optional since it will be loaded separately
}

export const orderStatuses = [
  // OrderStatusEnum.AWAITING,
  OrderStatusEnum.PROCESSING,
  OrderStatusEnum.READY_FOR_SHIPPING,
  OrderStatusEnum.IN_TRANSIT,
  OrderStatusEnum.COMPLETED,
  // OrderStatusEnum.VOIDED,
];

export enum ContainerTypeEnum {
  LITER_1000 = '1000_LITER',
  LITER_220 = '220_LITER',
}

export const containerTypes = [
  { value: ContainerTypeEnum.LITER_1000, label: '1000 Liter' },
  { value: ContainerTypeEnum.LITER_220, label: '220 Liter' },
];
